function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Plugin, Main_View_Id, EToolsKey, EvevtWorkState } from '@netless/appliance-plugin';
import { getGoogleAnalysis } from './server-api/google-api';
import { getIcons } from './server-api/iconify-api';
import { chat, getOpenRouterModelsByQuery } from './server-api/openRuter-api';
export * from './types';
function computRect(rect1, rect2) {
  if (rect1 && rect2) {
    const x = Math.min(rect1.x, rect2.x);
    const y = Math.min(rect1.y, rect2.y);
    const maxX = Math.max(rect1.x + rect1.w, rect2.x + rect2.w);
    const maxY = Math.max(rect1.y + rect1.h, rect2.y + rect2.h);
    const w = maxX - x;
    const h = maxY - y;
    return {
      x,
      y,
      w,
      h
    };
  }
  return rect2 || rect1;
}
export class AutoDrawPlugin extends Plugin {
  constructor(options) {
    super();
    _defineProperty(this, "kind", 'autoDraw');
    _defineProperty(this, "localStorage", []);
    _defineProperty(this, "excludeStorage", []);
    _defineProperty(this, "timer", void 0);
    _defineProperty(this, "iconsContainer", void 0);
    _defineProperty(this, "icons", []);
    _defineProperty(this, "iconRect", void 0);
    _defineProperty(this, "isActive", false);
    _defineProperty(this, "viewId", Main_View_Id);
    _defineProperty(this, "scenePath", void 0);
    _defineProperty(this, "delay", 2000);
    _defineProperty(this, "options", void 0);
    const {
      container,
      delay
    } = options;
    this.iconsContainer = container;
    this.delay = delay || 2000;
    this.options = options;
  }
  get collector() {
    return this.control.collector;
  }
  get roomUuid() {
    return this.control.room?.uuid;
  }
  get suid() {
    return this.control.room?.uid;
  }
  onDestroy() {
    this.unMount();
  }
  onCreate() {}
  onSetToolkey(key) {
    if (key === EToolsKey.Pencil) {
      this.isActive = true;
    } else {
      if (this.isActive) {
        this.localStorage.length = 0;
        this.timer && clearTimeout(this.timer);
        this.timer = undefined;
        if (this.iconRect) {
          this.iconRect = undefined;
        }
        this.icons.length = 0;
      }
      this.isActive = false;
    }
  }
  syncStorage(viewId, scenePath) {
    if (!this.isActive || viewId !== this.viewId) {
      return;
    }
    if (!scenePath) {
      this.localStorage.length = 0;
      return;
    }
    const ids = this.getOwnStorage(this.viewId, scenePath);
    this.localStorage = ids.map(id => this.collector?.getLocalId(id) || id);
  }
  getOwnStorage(viewId, scenePath) {
    if (!viewId || !scenePath) {
      return [];
    }
    const storage = this.collector?.storage[viewId]?.[scenePath];
    if (!storage) {
      return [];
    }
    const ids = Object.keys(storage).filter(id => this.collector?.isOwn(id) && storage[id]?.toolsType === EToolsKey.Pencil && !this.excludeStorage.includes(id));
    return ids;
  }
  async batchLocalDraw() {
    if (this.localStorage.length === 0) {
      return;
    }
    if (!this.scenePath) {
      return;
    }
    const storage = this.collector?.getStorageData(this.viewId, this.scenePath);
    if (!storage) {
      return undefined;
    }
    const _uuid = this.localStorage.toString();
    const info = await this.control.worker.getVNodeInfo(this.localStorage.toString(), this.viewId, this.localStorage);
    if (!info) {
      return undefined;
    }
    const {
      vInfo,
      uuid
    } = info;
    if (uuid === _uuid && vInfo) {
      const result = {
        rect: {
          centerX: 0,
          centerY: 0,
          width: 0,
          height: 0
        },
        ink: []
      };
      let r;
      const timerStamp = [];
      for (const {
        rect,
        op
      } of vInfo) {
        r = computRect(r, rect);
        const pointsX = [];
        const pointsY = [];
        for (let i = 0; i < op.length; i += 3) {
          pointsX.push(op[i]);
          pointsY.push(op[i + 1]);
          const lastTimerStamp = timerStamp.length && timerStamp[timerStamp.length - 1] || 0;
          if (i === 0) {
            if (timerStamp.length === 0) {
              timerStamp.push(0);
            } else {
              timerStamp.push(lastTimerStamp + 100);
            }
          } else {
            timerStamp.push(lastTimerStamp + 15);
          }
        }
        result.ink.push([pointsX, pointsY, timerStamp]);
      }
      if (r) {
        result.rect.centerX = Math.floor(r.x + r.w / 2);
        result.rect.centerY = Math.floor(r.y + r.h / 2);
        result.rect.width = Math.floor(r.w);
        result.rect.height = Math.floor(r.h);
      }
      return result;
    }
    return undefined;
  }
  async computAutoDraw(info) {
    const {
      rect,
      ink
    } = info;
    this.iconRect = rect;
    let iconNames = [];
    const {
      uploadFile,
      apiKey,
      customModel
    } = this.options;
    if (uploadFile && apiKey) {
      const snapshotFile = await this.getSnapshot(rect);
      if (snapshotFile) {
        const imageUrl = await uploadFile(snapshotFile);
        if (imageUrl) {
          const imageMultiModalId = customModel || (await getOpenRouterModelsByQuery({
            input_modalities: 'image',
            output_modalities: 'text',
            isFree: true
          }).then(res => {
            return res.data[0].id;
          }));
          const inputRequest = {
            model: imageMultiModalId,
            messages: [{
              role: 'user',
              content: [{
                type: 'text',
                text: "What's in this image? Return the icon names in the image, each icon name is separated by a comma."
              }, {
                type: 'image_url',
                image_url: {
                  url: imageUrl
                }
              }]
            }]
          };
          const imageMultiModalResponse = await chat(inputRequest, apiKey);
          if (imageMultiModalResponse.choices[0].message.content) {
            iconNames = imageMultiModalResponse.choices[0].message.content.split(',');
          }
        }
      }
    } else {
      iconNames = await getGoogleAnalysis(ink, rect.width, rect.height);
    }
    if (iconNames.length > 0) {
      const icons = await getIcons(iconNames);
      this.icons = icons;
    }
  }
  async getSnapshot(rect) {
    const focusScenePath = this.control.viewContainerManager.getView(this.viewId)?.focusScenePath;
    if (!focusScenePath) {
      return undefined;
    }
    const centerPoint = this.control.viewContainerManager.transformToScenePoint([rect.centerX, rect.centerY], this.viewId);
    const ImageBitmap = await this.control.worker.getSnapshot(focusScenePath, rect.width, rect.height, {
      centerX: centerPoint[0],
      centerY: centerPoint[1],
      scale: 1
    });
    if (ImageBitmap) {
      return this.imageBitmapToFile(ImageBitmap, `${this.roomUuid}-${this.suid}-snapshot.png`, 'image/png', 1);
    }
    return undefined;
  }
  async imageBitmapToFile(imageBitmap, fileName) {
    let mimeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'image/png';
    let quality = arguments.length > 3 ? arguments[3] : undefined;
    // Check if OffscreenCanvas is supported
    if (typeof OffscreenCanvas !== 'undefined') {
      // 1. Create a canvas (OffscreenCanvas is more efficient if available, especially in a worker)
      const canvas = new OffscreenCanvas(imageBitmap.width, imageBitmap.height);

      // 2. Get a rendering context (bitmaprenderer is most efficient as it avoids a pixel copy)
      const ctx = canvas.getContext('bitmaprenderer');
      if (ctx) {
        // 3. Draw the ImageBitmap to the canvas (transfers ownership to the canvas)
        ctx.transferFromImageBitmap(imageBitmap);

        // 4. Convert the canvas content to a Blob
        // convertToBlob is the correct method for OffscreenCanvas (returns a Promise)
        const blob = await canvas.convertToBlob({
          type: mimeType,
          quality
        });

        // 5. Create a File object from the Blob
        const file = new File([blob], fileName, {
          type: mimeType
        });
        return file;
      }
    }

    // Fallback: Use HTMLCanvasElement if OffscreenCanvas is not supported
    const canvas = document.createElement('canvas');
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      // Draw the ImageBitmap to the canvas
      ctx.drawImage(imageBitmap, 0, 0);

      // Convert to Blob using toBlob (callback-based for HTMLCanvasElement)
      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Failed to convert canvas to blob'));
          }
        }, mimeType, quality);
      });

      // Create a File object from the Blob
      const file = new File([blob], fileName, {
        type: mimeType
      });
      return file;
    }
    return undefined;
  }
  buildHTML() {
    this.iconsContainer.innerHTML = '';
    const box = document.createElement('div');
    box.style.display = 'flex';
    box.style.overflow = 'auto';
    box.style.padding = '10px 0';
    const color = this.control.worker.currentToolsData?.toolsOpt.strokeColor || '#7f7f7f';
    this.icons.forEach(icon => {
      const iconElement = document.createElement('img');
      iconElement.src = `https://api.iconify.design/${icon}.svg?color=${color}`;
      iconElement.onclick = () => {
        this.onClickIcon(icon);
      };
      iconElement.onload = () => {
        box.appendChild(iconElement);
      };
    });
    this.iconsContainer.appendChild(box);
  }
  onClickIcon(iconName) {
    if (this.iconRect) {
      const point = this.control.viewContainerManager.transformToScenePoint([this.iconRect.centerX, this.iconRect.centerY], this.viewId);
      const scale = this.control.viewContainerManager.getView(this.viewId)?.cameraOpt?.scale || 1;
      this.icons.length = 0;
      this.iconsContainer.innerHTML = '';
      const uuid = Date.now().toString();
      this.control.worker.removeNodes(this.viewId, this.localStorage);
      this.localStorage.length = 0;
      this.control.insertIconify(this.viewId, {
        uuid,
        centerX: point[0],
        centerY: point[1],
        width: Math.floor(this.iconRect.width / scale),
        height: Math.floor(this.iconRect.height / scale),
        src: `https://api.iconify.design/${iconName}.svg`,
        uniformScale: false,
        locked: false
      });
      this.iconRect = undefined;
    }
  }
  sceneChange(viewId, scenePath) {
    if (viewId === this.viewId) {
      this.scenePath = scenePath;
      this.excludeStorage = this.getOwnStorage(viewId, scenePath);
    }
    this.localStorage.length = 0;
  }
  localEvent(viewId, eventState) {
    if (viewId === this.viewId && this.control.worker.currentToolsData?.toolsType === EToolsKey.Pencil) {
      switch (eventState) {
        case EvevtWorkState.Start:
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = undefined;
          }
          break;
        case EvevtWorkState.Done:
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(async () => {
            this.timer = undefined;
            const info = await this.batchLocalDraw();
            if (!info) {
              return;
            }
            await this.computAutoDraw(info);
            this.buildHTML();
          }, this.delay);
          break;
        default:
          break;
      }
    }
  }
  mount() {
    this.scenePath = this.control.viewContainerManager.getView(this.viewId)?.focusScenePath;
    this.excludeStorage = this.getOwnStorage(this.viewId, this.scenePath);
    const key = this.control.worker.currentToolsData?.toolsType;
    key && this.onSetToolkey(key);
    this.callbacks('setToolkey', this.onSetToolkey.bind(this));
    this.callbacks('syncStorage', this.syncStorage.bind(this));
    this.callbacks('sceneChange', this.sceneChange.bind(this));
    this.callbacks('localEvent', this.localEvent.bind(this));
  }
  unMount() {
    this.timer && clearTimeout(this.timer);
    this.timer = undefined;
    if (this.iconRect) {
      this.iconRect = undefined;
    }
    this.icons.length = 0;
    this.excludeStorage.length = 0;
    this.localStorage.length = 0;
    this.iconsContainer.innerHTML = '';
    this.removeCallback('setToolkey');
    this.removeCallback('syncStorage');
    this.removeCallback('sceneChange');
    this.removeCallback('localEvent');
  }
}